import moment from 'moment';

import { GENERAL_INITIAL_VALUES } from './constants';
import { API_DATE_FORMAT } from '../../../../../../constants';

import type { GeneralFormValues, QuestionnaireGeneralInfoPayload } from '../../../../common';
import type { GeneralInfoFieldName } from './types';
import type { IIntakeQuestionnaireGeneralInfo } from '../../../../../../store/questionnaires/intake';

export function getIntakeGeneralInfoInitialValues(
  generalInfo: IIntakeQuestionnaireGeneralInfo | null | undefined,
): GeneralFormValues {
  if (generalInfo == null) {
    return GENERAL_INITIAL_VALUES;
  }

  return {
    provider_full_name: generalInfo.provider_full_name ?? '',
    provider_email: generalInfo.provider_email ?? '',
    primary_language: generalInfo.primary_language ?? '',
    relationship_to_client: generalInfo.relationship_to_client ?? '',
    client_first_name: generalInfo.client_first_name ?? '',
    client_middle_name: generalInfo.client_middle_name ?? '',
    client_last_name: generalInfo.client_last_name ?? '',
    client_date_of_birth: generalInfo.client_date_of_birth
      ? moment(generalInfo.client_date_of_birth)
      : null,
    client_sex: generalInfo.client_sex ?? '',
    client_address_same_as_provider: generalInfo.client_address_same_as_provider ?? false,
    client_street_address_line_one: generalInfo.client_street_address_line_one ?? '',
    client_street_address_line_two: generalInfo.client_street_address_line_two ?? '',
    client_street_address_zip: generalInfo.client_street_address_zip ?? '',
    client_street_address_city: generalInfo.client_street_address_city ?? '',
    client_street_address_state: generalInfo.client_street_address_state ?? '',
  };
}

export function toGeneralInfoFieldPatch(
  name: GeneralInfoFieldName,
  values: GeneralFormValues,
): Partial<QuestionnaireGeneralInfoPayload> {
  const data: Partial<QuestionnaireGeneralInfoPayload> = {};

  if (name === 'client_date_of_birth') {
    data.client_date_of_birth = values.client_date_of_birth?.format(API_DATE_FORMAT) ?? '';
    return data;
  }
  if (name === 'client_sex') {
    data.client_sex = values.client_sex.toLowerCase();
    return data;
  }
  if (name === 'client_address_same_as_provider') {
    data.client_address_same_as_provider = values.client_address_same_as_provider;
    return data;
  }

  const fieldValue = values[name];
  data[name] = fieldValue ?? '';
  return data;
}
